export const CLUBS_BASE_URL = "clubs";
export const DASHBOARD_CLUBS_URL = `${CLUBS_BASE_URL}/dashboard`;
export const USERS_BASE_URL = "users";
export const EMAIL_VERIFICATION_URL = `${USERS_BASE_URL}/verify`;
export const APPLICATIONS_URL = "club-applications";
export const USER_APPLICATIONS = "applications";
export const CANCELLATION = "cancellation";
export const REASONS = "reasons";
export const NOTIFICATIONS_URL = "notifications";
export const MARK_NOTIFICATION = "mark";
export const ALL = "all";
export const TOGGLE_NOTIFICATION = `${NOTIFICATIONS_URL}/${MARK_NOTIFICATION}`;
export const MARK_ALL = `${NOTIFICATIONS_URL}/${MARK_NOTIFICATION}/${ALL}`;
export const WHITELISTING_URL = "whitelisting";
export const SAVE = "save";
export const UPDATE = "update";
export const DEPOSITS = "deposits";
